import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Contact from "@/pages/Contact";

const ScrollManager = ({ lenisRef }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenisRef]);
  return null;
};

const PageShell = ({ children }) => (
  <motion.main
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager lenisRef={lenisRef} />
        <div className="noise-overlay" aria-hidden="true" />
        <Nav />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<PageShell><Home /></PageShell>} />
            <Route path="/le-studio" element={<PageShell><Studio /></PageShell>} />
            <Route path="/services" element={<PageShell><Services /></PageShell>} />
            <Route path="/portfolio" element={<PageShell><Portfolio /></PageShell>} />
            <Route path="/contact" element={<PageShell><Contact /></PageShell>} />
          </Routes>
        </AnimatePresence>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#232323",
              border: "1px solid rgba(200,166,106,0.35)",
              color: "#F3F0EA",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
